import { IMAGE_URL } from "../../path";
import React, { useState, useEffect } from "react";

interface ImageTextProps {
    id: number;
    image_first: boolean;
    body_copy: string;
    image_path: string;
    title?: string;
    date_posted?: string;
}

function CustomImageTextComponent(props: ImageTextProps) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const formattedBodyCopy = props.body_copy;

    return (
        <div>
            <div style={{width: windowWidth > 575 ? '70%' : '90%', margin: '0 auto', marginBottom: '100px', display: 'flex', flexDirection: windowWidth > 575 ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'flex-start', gap: '46px' }}>
                {props.image_first ? <>
                    <div style={{ flex: 1}}>
                        <img src={IMAGE_URL + props.image_path} alt={props.image_path} style={{width: '100%'}} />
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        {(props.title || props.date_posted) && (
                            <header className="body-header" style={{marginTop: 0, paddingTop: 0}}>
                                {props.title && <p className="body-title" style={{textAlign: 'left'}}>{props.title}</p>}
                                {props.date_posted && <p className="body-date" style={{textAlign: 'left'}}>{props.date_posted}</p>}
                            </header>
                        )}
                        <div className="body-content" dangerouslySetInnerHTML={{ __html: props.body_copy }} />
                    </div>
                </> : <>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        {(props.title || props.date_posted) && (
                            <header className="body-header" style={{marginTop: 0, paddingTop: 0}}>
                                {props.title && <p className="body-title" style={{textAlign: 'left'}}>{props.title}</p>}
                                {props.date_posted && <p className="body-date" style={{textAlign: 'left'}}>{props.date_posted}</p>}
                            </header>
                        )}
                        <div className="body-content" dangerouslySetInnerHTML={{ __html: props.body_copy }} />
                    </div>
                    <div style={{flex: 1}}>
                        <img src={IMAGE_URL + props.image_path} alt={props.image_path} style={{width: '100%'}} />
                    </div>
                </>}

            </div>
        </div>
    );
}

export default CustomImageTextComponent;
